import React from "react";
import cns from "classnames";
import { Color, WithPopperSimple } from "@bonliva-crm/ui";
import { TableCell, makeStyles } from "@material-ui/core";

type Props = {
  title: string;
  tooltipTitle: React.ReactElement | null;
  onMouseDown: (e: React.SyntheticEvent) => void;
  onMouseUp: (e: React.SyntheticEvent) => void;
  onMouseEnter: (e: React.SyntheticEvent) => void;

  extra?: React.ReactNode;
  disabled?: boolean;

  isSelectedOuter: boolean;
  isSelectedInner: boolean;
};

export function CalendarCell(props: Props) {
  const classes = useStyles({});

  return (
    <WithPopperSimple
      component={TableCell}
      className={cns(classes.tableCell, classes.weekTableCell, {
        [classes.disabled]: props.disabled,
        [classes.innerSelectedCell]: props.isSelectedInner,
        [classes.outerSelectedCell]: props.isSelectedOuter
      })}
      popperContent={(popperProps) =>
        props.tooltipTitle ? (
          React.cloneElement(props.tooltipTitle!, { onClick: popperProps.close })
        ) : (
          <span />
        )
      }
    >
      {(popperContentProps) => (
        <div
          style={{ padding: "8px" }}
          onMouseDown={props.onMouseDown}
          onMouseUp={props.onMouseUp}
          onMouseEnter={(event) => {
            popperContentProps.open();
            props.onMouseEnter(event);
          }}
          onMouseLeave={() => popperContentProps.closeWithDelay()}
        >
          {props.title}
          {props.extra}
        </div>
      )}
    </WithPopperSimple>
  );
}

const useStyles = makeStyles({
  tableCell: {
    border: "none",
    userSelect: "none",
    padding: 0
  },
  weekTableCell: {
    cursor: "pointer",
    textAlign: "center",
    position: "relative",
    "&:hover": {
      backgroundColor: Color.PrimaryLight
    }
  },
  disabled: {
    pointerEvents: "none",
    opacity: 0.5
  },
  innerSelectedCell: {
    backgroundColor: Color.PrimaryLight
  },
  outerSelectedCell: {
    backgroundColor: Color.PrimaryMain,
    color: Color.White
  }
});
